import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { BonusStatus, OCC_ENDPOINTS } from '@my-account/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BonusStatusApiService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadBonusStatus(): Observable<BonusStatus> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.bonusStatus);

    return this.http.post<BonusStatus>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.bonusStatus),
    });
  }
}
